<template>
    <div style="height: 100%; overflow: hidden;">
        <!-- 7天日期选择器 -->
        <a-row style="margin-bottom: 10px;">
            <a-col :span="24">
                <a-flex justify="space-between" align="center" style="overflow-x: auto;">
                    <a-popover 
                        :open="show_calendar_popover" 
                        trigger="click" 
                        placement="bottomLeft"
                        :overlayStyle="{ padding: 0 }"
                        @openChange="onPopoverOpenChange"
                    >
                        <template #content>
                            <div @click.stop style="padding: 8px;" v-if="show_calendar_popover">
                                <a-date-picker
                                    :key="`datepicker-${calendar_key}`"
                                    :disabled-date="disabledDateComputed"
                                    :inputReadOnly="true"
                                    format="YYYY-MM-DD"
                                    @change="onCalendarDateChange"
                                    @ok="onCalendarDateChange"
                                />
                            </div>
                        </template>
                        <a-button style="min-width: 40px;" @click="openCalendar">
                            <CalendarOutlined />
                        </a-button>
                    </a-popover>
                    <a-button @click="prevWeek" style="min-width: 40px;">
                        <LeftOutlined />
                    </a-button>
                    <a-flex gap="small" style="flex: 1; justify-content: space-around; min-width: 0;">
                        <div
                            v-for="(dateItem, index) in week_dates"
                            :key="index"
                            class="date-selector-item"
                            :class="{ 'selected': selected_date && selected_date.date_str === dateItem.date_str }"
                            @click="selectDate(dateItem)"
                        >
                            {{ dateItem.display }}
                        </div>
                    </a-flex>
                    <a-button @click="nextWeek" style="min-width: 40px;">
                        <RightOutlined />
                    </a-button>
                </a-flex>
            </a-col>
        </a-row>

        <!-- 统计信息 -->
        <a-row style="margin-bottom: 10px;">
            <a-col :span="12">
                <span>TOTAL WAITLIST {{ list.length }}({{ total_count }})</span>
            </a-col>
            <a-col :span="12" style="text-align: right;">
                <span>SORT BY JOIN TIME</span>
            </a-col>
        </a-row>

        <a-divider />

        <!-- 列表展示 -->
        <a-list
            class="demo-loadmore-list"
            item-layout="horizontal"
            :data-source="list"
            style="margin-top: 10px; overflow: auto; height: 80%;"
            :style="{height: is_mobile ? '70vh' : '75vh'}"
            :loading="is_loading"
        >
            <template #renderItem="{ item }">
                <a-list-item 
                    :style="{backgroundColor: item.color_tags && item.color_tags.length > 0 ? item.color_tags[0].color : '#fff'}" 
                    style="margin-top: 7px; height: 100px;"
                >
                    <a-list-item-meta @click="doShowInfoLayer(item)">
                        <template #title>
                            <span>{{ item.customer_name + '(' + item.people_num + ')' }}</span>
                            <a-tag v-if="item.visit_count && item.visit_count > 0" color="#87d068" style="margin-left: 10px;">
                                {{ item.visit_count }} VISITS
                            </a-tag>
                            <div> 
                                {{ item.wait_code + ' | ' + item.phone_num }}
                                <span style="margin-left: 10px;">
                                    <PhoneOutlined v-if="item.source === 'manual_admin'" :style="{fontSize: '16px'}" />
                                    <QrcodeOutlined v-else-if="item.source === 'qr_guest'" :style="{fontSize: '16px'}" />
                                    <GoogleOutlined v-else-if="item.source === 'google'" :style="{fontSize: '16px'}" />
                                    <TabletOutlined v-else-if="item.source === 'manual_guest'" :style="{fontSize: '16px'}" />
                                </span>
                            </div>
                            <div style="white-space: nowrap; overflow: hidden; margin-top: 5px;">
                                <span v-if="item.note">
                                    <AlertFilled />
                                    <span style="text-decoration: underline;">{{ item.note }}</span>
                                </span>
                                <span v-if="item.options" style="margin-left: 10px;">
                                    <BorderlessTableOutlined />
                                    {{ item.options }}
                                </span>
                            </div>
                            <div v-if="item.missed == 1" style="color: red; margin-top: 5px;">
                                <FieldTimeOutlined style="margin-right: 5px;" />
                                {{ moment.tz(item.missed_timestamp * 1, timezone).format('HH:mm') }}
                                <HomeOutlined style="margin-left: 10px; margin-right: 5px;" />
                                <span>Manual no show</span>
                            </div>
                        </template>
                        <template #avatar>
                            <div 
                                class="custom_big_btn" 
                                :class="{
                                    red_color1: item.missed == 1 || item.pre_tstatus == 11, 
                                    green_color1: item.table_ready_result == 1, 
                                    yellow_color1: item.table_ready_sent == 1 && item.table_ready_result == 0, 
                                    yellow_color2: item.pre_tstatus == 6 || item.all_arrived > 0
                                }" 
                                style="padding-top: 10px; width: 120px;"
                            >
                                <h4>{{ item.wait_from_now }}</h4>
                                <h5 v-if="item.missed == 0 && item.pre_tstatus < 2">
                                    <span v-if="item.all_arrived == 0">{{ $t('waitlist.waiting') }}</span>
                                    <span v-if="item.all_arrived == 2">
                                        {{ $t('waitlist.partial_arrived') }}
                                    </span>
                                    <span v-if="item.all_arrived == 1">
                                        {{ $t('waitlist.all_arrived') }}
                                    </span>
                                </h5>
                                <h5 v-if="item.pre_tstatus == 6">{{ $t('waitlist.checked_in') }}</h5>
                                <h5 v-if="item.missed == 1">{{ $t('waitlist.no_show') }}</h5>
                                <h5 v-if="item.pre_tstatus == 11">{{ $t('waitlist.left') }}</h5>
                                <h5 v-if="item.pre_tstatus == 16">{{ $t('waitlist.expired') }}</h5>
                            </div>
                        </template>
                    </a-list-item-meta>
                    <div style="text-align: right; padding-top: 10px;">
                        <div style="margin-bottom: 10px;">
                            <UserOutlined style="margin-right: 5px;" />
                            <span>{{ item.join_time }}</span>
                        </div>
                    </div>
                </a-list-item>
            </template>
        </a-list>

        <!-- 详情弹层 -->
        <a-drawer 
            class="user_info_zone" 
            :zIndex="1000" 
            @close="doHideInfoLayer" 
            v-model:open="show_info_layer" 
            placement="right" 
            :width="!is_mobile ? 400 : 375" 
            :footer="null"
        >
            <div class="user_info_header">
                <a-row>
                    <a-col :span="9">
                        <div 
                            class="custom_big_btn" 
                            :class="{
                                red_color1: layer_user_info.missed == 1 || layer_user_info.pre_tstatus == 11, 
                                green_color1: layer_user_info.table_ready_result == 1, 
                                yellow_color2: layer_user_info.pre_tstatus == 6 || layer_user_info.all_arrived > 0, 
                                yellow_color1: layer_user_info.table_ready_sent == 1 && layer_user_info.table_ready_result == 0
                            }" 
                            style="padding-top: 10px; width: 120px;"
                        >
                            <h3>{{ layer_user_info.wait_from_now }}</h3>
                            <h5 v-if="layer_user_info.missed == 0 && layer_user_info.pre_tstatus < 2">
                                <span v-if="layer_user_info.all_arrived == 0">{{ $t('waitlist.waiting') }}</span>
                                <span v-if="layer_user_info.all_arrived == 2">
                                    {{ $t('waitlist.partial_arrived') }}
                                </span>
                                <span v-if="layer_user_info.all_arrived == 1">
                                    {{ $t('waitlist.all_arrived') }}
                                </span>
                            </h5>
                            <h5 v-if="layer_user_info.pre_tstatus == 6">{{ $t('waitlist.checked_in') }}</h5>
                            <h5 v-if="layer_user_info.missed == 1">{{ $t('waitlist.no_show') }}</h5>
                            <h5 v-if="layer_user_info.pre_tstatus == 11">{{ $t('waitlist.left') }}</h5>
                            <h5 v-if="layer_user_info.pre_tstatus == 16">{{ $t('waitlist.expired') }}</h5>
                        </div>
                    </a-col>
                    <a-col :span="14">
                        <div>
                            <h4>{{ layer_user_info.people_num }} | {{ layer_user_info.customer_name }}</h4>
                            <p style="margin-bottom: 5px;">{{ layer_user_info.phone_num }}</p>
                            <span v-for="item in layer_user_info.guest_tags" v-bind:key="item.name">
                                <a-tag :color="item.color">{{ item.name }}</a-tag>
                            </span>
                        </div>
                    </a-col>
                </a-row>
            </div>
            <a-divider />
            <div class="user_waitlist_data">
                <h4 style="background: #f5f5f5;line-height: 30px;">{{ $t('waitlist.waitlist_detail') }}</h4>
                <div>
                    <a-button style="background-color: #f5f5f5;">{{ layer_user_info.wait_code }}</a-button>
                </div>
                <div style="margin-top: 10px;" v-if="layer_user_info.note">
                    <a-input 
                        v-model:value="layer_user_info.note" 
                        :disabled="true" 
                        style="width: 100%" 
                        :placeholder="$t('waitlist.visit_note')"
                    >
                        <template #prefix>
                            <FormOutlined />
                        </template>
                    </a-input>
                </div>
            </div>
            <div class="user_timeline">
                <h4 style="background: #f5f5f5;line-height: 30px;">{{ $t('waitlist.timeline') }}</h4>
                <a-timeline v-if="!is_loading_timeline" style="height: 170px; overflow: auto; padding-top: 5px;">
                    <a-timeline-item v-for="(item,index) in timeline_list" v-bind:key="item.title + index">
                        {{ item.title }}
                    </a-timeline-item>
                </a-timeline>
                <a-skeleton active v-if="is_loading_timeline" />
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {
        LeftOutlined,
        RightOutlined,
        AlertFilled,
        BorderlessTableOutlined,
        FieldTimeOutlined,
        HomeOutlined,
        UserOutlined,
        PhoneOutlined,
        FormOutlined,
        CalendarOutlined,
        QrcodeOutlined,
        GoogleOutlined,
        TabletOutlined,
    } from '@ant-design/icons-vue';

    import { mapActions } from 'vuex';
    import moment from 'moment-timezone';

    export default {
        name: 'WaitlistHistoryView',
        components: {
            LeftOutlined,
            RightOutlined,
            AlertFilled,
            BorderlessTableOutlined,
            FieldTimeOutlined,
            HomeOutlined,
            UserOutlined,
            PhoneOutlined,
            FormOutlined,
            CalendarOutlined,
            QrcodeOutlined,
            GoogleOutlined,
            TabletOutlined,
        },
        data() {
            return {
                sid: this.$store.state.app.sid,
                timezone: this.$store.state.app.timezone,
                is_mobile: this.$store.state.app.is_mobile,
                moment,
                
                // 日期相关
                week_dates: [],
                selected_date: null,
                week_offset: 0,
                current_date_display: '',
                show_calendar_popover: false,
                calendar_key: 0,
                
                // 列表相关
                list: [],
                current: 1,
                page_size: 20,
                total_count: 0,
                is_loading: false,
                
                // 详情弹层
                show_info_layer: false,
                layer_user_info: {},
                timeline_list: [],
                is_loading_timeline: false,
                
            };
        },
        mounted() {
            this.generateWeekDates(0);
            this.selectToday();
        },
        created() {
            let _sid = window.localStorage.getItem('sid') || '';
            let _token = window.localStorage.getItem('token') || '';

            if (!_sid || !_token) {
                window.location.replace('/login');
            }
        },
        computed: {
            // 计算属性：禁用日期函数，避免每次渲染创建新函数
            disabledDateComputed() {
                const timezone = this.timezone;
                return (current) => {
                    if (!current) {
                        return false;
                    }
                    const today = moment.tz(timezone).endOf('day');
                    return current.isAfter(today);
                };
            }
        },
        methods: {
            ...mapActions({
                do_get_request: 'waitlist/do_get_request'
            }),
            // 打开日历
            openCalendar() {
                this.show_calendar_popover = true;
                this.calendar_key += 1; // 每次打开时强制重新渲染
            },
            // Popover打开/关闭状态变化
            onPopoverOpenChange(open) {
                this.show_calendar_popover = open;
                if (!open) {
                    this.calendar_key += 1; // 关闭时也更新key
                }
            },
            // 生成7天日期数组
            generateWeekDates(offset) {
                const today = moment.tz(this.timezone);
                // 获取当前周的周一（如果今天是周日，则取上周一）
                let startOfWeek = today.clone().startOf('week').add(1, 'day');
                if (today.day() === 0) {
                    // 如果今天是周日，周一是上一周
                    startOfWeek = today.clone().subtract(6, 'days');
                }
                const currentWeekStart = startOfWeek.clone().add(offset * 7, 'days');
                
                const weekDates = [];
                const weekDayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
                
                for (let i = 0; i < 7; i++) {
                    const date = currentWeekStart.clone().add(i, 'days');
                    weekDates.push({
                        date_str: date.format('YYYY-MM-DD'),
                        display: weekDayNames[i] + ', ' + date.format('MMM DD'),
                        moment: date
                    });
                }
                
                this.week_dates = weekDates;
            },
            // 选择今天
            selectToday() {
                const today = moment.tz(this.timezone).format('YYYY-MM-DD');
                const todayItem = this.week_dates.find(item => item.date_str === today);
                
                if (todayItem) {
                    this.selected_date = todayItem;
                } else {
                    // 如果今天不在当前周，重置到当前周并选择今天
                    this.week_offset = 0;
                    this.generateWeekDates(0);
                    const newTodayItem = this.week_dates.find(item => item.date_str === today);
                    this.selected_date = newTodayItem || this.week_dates[0];
                }
                
                this.updateCurrentDateDisplay();
                this.get_history_list();
            },
            // 选择日期
            selectDate(dateItem) {
                const today = moment.tz(this.timezone);
                
                // 确保不能选择未来日期
                if (dateItem.moment > today) {
                    this.$message.warning('不能选择未来日期');
                    return;
                }
                
                this.selected_date = dateItem;
                this.updateCurrentDateDisplay();
                this.current = 1;
                this.get_history_list();
            },
            // 上一周
            prevWeek() {
                this.week_offset -= 1;
                this.generateWeekDates(this.week_offset);
                
                // 保持选中相同的星期几
                if (this.selected_date) {
                    const dayOfWeek = this.selected_date.moment.day() === 0 ? 6 : this.selected_date.moment.day() - 1;
                    this.selected_date = this.week_dates[dayOfWeek];
                } else {
                    this.selected_date = this.week_dates[0];
                }
                
                this.updateCurrentDateDisplay();
                this.current = 1;
                this.get_history_list();
            },
            // 下一周
            nextWeek() {
                const today = moment.tz(this.timezone);
                const nextWeekOffset = this.week_offset + 1;
                
                // 检查下一周的第一天是否超过今天
                let startOfWeek = today.clone().startOf('week').add(1, 'day');
                if (today.day() === 0) {
                    startOfWeek = today.clone().subtract(6, 'days');
                }
                const nextWeekStart = startOfWeek.clone().add(nextWeekOffset * 7, 'days');
                
                // 如果下一周的第一天超过今天，不允许切换
                if (nextWeekStart > today) {
                    this.$message.warning('不能选择未来日期');
                    return;
                }
                
                this.week_offset = nextWeekOffset;
                this.generateWeekDates(this.week_offset);
                
                // 保持选中相同的星期几，但不能超过今天
                if (this.selected_date) {
                    const dayOfWeek = this.selected_date.moment.day() === 0 ? 6 : this.selected_date.moment.day() - 1;
                    const targetDate = this.week_dates[dayOfWeek];
                    
                    // 确保选中的日期不超过今天
                    if (targetDate && targetDate.moment <= today) {
                        this.selected_date = targetDate;
                    } else {
                        // 如果目标日期超过今天，选择今天或最近的一个日期
                        const todayStr = today.format('YYYY-MM-DD');
                        const todayItem = this.week_dates.find(item => item.date_str === todayStr);
                        if (todayItem) {
                            this.selected_date = todayItem;
                        } else {
                            // 选择不超过今天的最后一个日期
                            const validDates = this.week_dates.filter(item => item.moment <= today);
                            this.selected_date = validDates[validDates.length - 1] || this.week_dates[0];
                        }
                    }
                } else {
                    this.selected_date = this.week_dates[0];
                }
                
                this.updateCurrentDateDisplay();
                this.current = 1;
                this.get_history_list();
            },
            // 更新当前日期显示
            updateCurrentDateDisplay() {
                if (this.selected_date) {
                    const weekDayMap = {
                        0: '周日',
                        1: '周一',
                        2: '周二',
                        3: '周三',
                        4: '周四',
                        5: '周五',
                        6: '周六'
                    };
                    const dayOfWeek = this.selected_date.moment.day();
                    this.current_date_display = this.selected_date.moment.format('M月D日') + weekDayMap[dayOfWeek];
                }
            },
            // 日历选择器日期变化
            onCalendarDateChange(date) {
                if (!date) {
                    return;
                }
                
                const selectedDateStr = date.format('YYYY-MM-DD');
                const today = moment.tz(this.timezone).format('YYYY-MM-DD');
                
                // 确保不能选择未来日期
                if (selectedDateStr > today) {
                    this.$message.warning('不能选择未来日期');
                    // 不更新任何状态，直接返回
                    return;
                }
                
                // 立即关闭popover
                this.show_calendar_popover = false;
                this.calendar_key += 1; // 强制重新渲染
                
                // 计算该日期所在的周
                const selectedMoment = moment.tz(selectedDateStr, 'YYYY-MM-DD', this.timezone);
                const todayMoment = moment.tz(this.timezone);
                
                // 计算周偏移量
                let startOfWeek = todayMoment.clone().startOf('week').add(1, 'day');
                if (todayMoment.day() === 0) {
                    startOfWeek = todayMoment.clone().subtract(6, 'days');
                }
                
                let selectedWeekStart = selectedMoment.clone().startOf('week').add(1, 'day');
                if (selectedMoment.day() === 0) {
                    selectedWeekStart = selectedMoment.clone().subtract(6, 'days');
                }
                
                const weekDiff = selectedWeekStart.diff(startOfWeek, 'weeks');
                this.week_offset = weekDiff;
                
                // 生成新的周日期
                this.generateWeekDates(this.week_offset);
                
                // 选择对应的日期
                const targetDate = this.week_dates.find(item => item.date_str === selectedDateStr);
                if (targetDate) {
                    this.selected_date = targetDate;
                } else {
                    // 如果不在当前周，选择该周的第一天
                    this.selected_date = this.week_dates[0];
                }
                
                this.updateCurrentDateDisplay();
                this.current = 1;
                this.get_history_list();
            },
            // 获取历史列表
            async get_history_list() {
                if (!this.selected_date) {
                    return;
                }
                
                this.is_loading = true;
                
                try {
                    let res_data = await this.do_get_request({
                        sid: this.sid,
                        page: this.current,
                        page_size: this.page_size,
                        sdate: this.selected_date.date_str,
                        edate: this.selected_date.date_str,
                        orderby: 'create_time',
                        api: '/weapp/admin/preorder/history'
                    });

                    if (res_data.code == 100000) {
                        this.list = (res_data.data.list || []).map(item => {
                            // 计算等待时间，如果有结束时间使用结束时间，否则使用当前时间或更新时间
                            let endTime = null;
                            if (item.missed_timestamp && item.missed == 1) {
                                endTime = item.missed_timestamp * 1;
                            } else if (item.update_timestamp) {
                                endTime = item.update_timestamp * 1;
                            }
                            item.wait_from_now = this.custom_from_now(item.create_timestamp * 1, endTime);
                            item.phone_num = item.phone_num || '';
                            item.join_time = moment.tz(item.create_timestamp * 1, this.timezone).format('HH:mm');
                            
                            // 确保有默认值
                            item.people_num = item.people_num || 0;
                            item.customer_name = item.customer_name || '';
                            item.wait_code = item.wait_code || '';
                            item.pre_tstatus = item.pre_tstatus || 0;
                            item.missed = item.missed || 0;
                            
                            let options = [];
                            if (item.options) {
                                for (var o in item.options) {
                                    var opvalue = item.options[o].split('@@');
                                    var subvalue = '';

                                    if (opvalue.length > 1) {
                                        subvalue = opvalue[1].split('=')[1];
                                        subvalue = '- ' + subvalue;
                                    }

                                    options.push(o + ':' + opvalue[0] + subvalue);
                                }
                            }
                            item.options = options.join(' | ');

                            return item;
                        });

                        this.total_count = res_data.data.total_count || res_data.data.list.length;
                        this.page_size = res_data.data.page_size || 20;
                    }
                } catch (error) {
                    console.error('获取历史列表失败:', error);
                } finally {
                    this.is_loading = false;
                }
            },
            // 计算时间差
            custom_from_now(timestamp, end_time) {
                let now_time = new Date().getTime();
                if (end_time) {
                    now_time = end_time * 1;   
                }

                let diff = now_time - timestamp * 1;

                let hours = Math.floor(diff / (60 * 60 * 1000));
                let minutes = Math.floor((diff - hours * 60 * 60 * 1000) / (60 * 1000));

                minutes = minutes == 0 ? 1 : minutes;

                if (hours > 0) {
                    return hours + 'h ' + minutes + 'm';
                }

                return minutes + 'm';
            },
            // 显示详情弹层
            doShowInfoLayer(item) {
                this.show_info_layer = true;
                this.layer_user_info = { ...item };
                this.get_timeline();
                this.get_guest_tag();
            },
            // 隐藏详情弹层
            doHideInfoLayer() {
                this.show_info_layer = false;
                this.layer_user_info = {};
                this.timeline_list = [];
            },
            // 获取时间线
            async get_timeline() {
                if (!this.layer_user_info.pre_tid) {
                    return;
                }
                
                this.is_loading_timeline = true;
                
                try {
                    let res_data = await this.do_get_request({
                        sid: this.sid,
                        type: 'preorder',
                        id: this.layer_user_info.pre_tid,
                        api: '/weapp/admin/message/get'
                    });

                    let message_status = [this.$t('common.sending'), this.$t('common.send_success'), this.$t('common.send_error')];

                    let data_list = [];
                    if (res_data.code == 100000) {
                        let notification_list = res_data.data.list || [];

                        data_list.push({
                            title: moment.tz(this.layer_user_info.create_timestamp * 1, this.timezone).format('HH:mm A') + ' ' + this.$t('waitlist.join_waitlist'),
                            detail: '',
                            timestamp: this.layer_user_info.create_timestamp
                        });

                        notification_list.map(item => {
                            data_list.push({
                                title: moment.tz(item.create_timestamp * 1, this.timezone).format('HH:mm A') + ' ' + this.$t(`common.${item.type}`) + '(' + message_status[item.status] + ')',
                                detail: item.content,
                                timestamp: item.create_timestamp
                            });
                        });

                        if (this.layer_user_info.missed_timestamp) {
                            data_list.push({
                                title: moment.tz(this.layer_user_info.missed_timestamp * 1, this.timezone).format('HH:mm A') + ' ' + this.$t('waitlist.no_show'),
                                detail: '',
                                timestamp: this.layer_user_info.missed_timestamp
                            });
                        }

                        if (this.layer_user_info.checkedin_timestamp) {
                            data_list.push({
                                title: moment.tz(this.layer_user_info.checkedin_timestamp * 1, this.timezone).format('HH:mm A') + ' ' + this.$t('waitlist.checked_in'),
                                detail: '',
                                timestamp: this.layer_user_info.checkedin_timestamp
                            });
                        }

                        if (this.layer_user_info.recover_timestamp) {
                            data_list.push({
                                title: moment.tz(this.layer_user_info.recover_timestamp * 1, this.timezone).format('HH:mm A') + ' ' + this.$t('waitlist.restore'),
                                detail: '',
                                timestamp: this.layer_user_info.recover_timestamp
                            });
                        }

                        if (this.layer_user_info.arrived_time > 0) {
                            data_list.push({
                                title: moment.tz(this.layer_user_info.arrived_time * 1, this.timezone).format('HH:mm A') + ' ' + (this.layer_user_info.all_arrived == 1 ? this.$t('waitlist.all_arrived') : this.$t('waitlist.partial_arrived')),
                                detail: '',
                                timestamp: this.layer_user_info.arrived_time
                            });
                        }

                        data_list = data_list.sort((a, b) => a.timestamp - b.timestamp);

                        this.timeline_list = data_list;
                    }
                } catch (error) {
                    console.error('获取时间线失败:', error);
                } finally {
                    this.is_loading_timeline = false;
                }
            },
            // 获取客户标签
            async get_guest_tag() {
                if (!this.layer_user_info.phone_num) {
                    return;
                }

                try {
                    let res_data = await this.do_get_request({
                        sid: this.sid,
                        phone_num_list: this.layer_user_info.phone_num,
                        api: '/weapp/admin/guests/tag/get',
                        method: 'post'
                    });

                    if (res_data.code == 100000) {
                        let guest_info = res_data.data.length > 0 ? res_data.data[0] : {};
                        let new_tags_arr = [];
                        new_tags_arr.push({
                            name: (guest_info.wait_count + guest_info.reservation_count) + ' ' + this.$t('common.visits'),
                            color: '#87d068'
                        });

                        new_tags_arr.push({
                            name: guest_info.missed_count + ' ' + this.$t('waitlist.no_show'),
                            color: 'red'
                        });

                        if (guest_info.tags) {
                            guest_info.tags.map(item => {
                                new_tags_arr.push({
                                    name: '!' + item.tname,
                                    color: 'red'
                                });
                            });
                        }

                        this.layer_user_info.guest_tags = new_tags_arr;
                        this.layer_user_info.visit_count = guest_info.wait_count + guest_info.reservation_count;
                    }
                } catch (error) {
                    console.error('获取客户标签失败:', error);
                }
            }
        }
    }
</script>

<style scoped>
    .date-selector-item {
        padding: 8px 12px;
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
        min-width: 80px;
        transition: all 0.3s;
        border: 1px solid #d9d9d9;
        background-color: #fff;
    }

    .date-selector-item:hover {
        background-color: #f0f0f0;
        border-color: #40a9ff;
    }

    .date-selector-item.selected {
        background-color: #52c41a;
        color: #fff;
        font-weight: bold;
        border-color: #52c41a;
    }

    .custom_big_btn {
        display: inline-block;
        height: 75px;
        width: 100px;
        border-radius: 5px;
        border: 1px solid #d7cdcd;
        text-align: center;
        padding: 5px;
        cursor: pointer;
        background-color: #fff;
    }

    .user_info_zone .ant-drawer-body {
        overflow: hidden;
        padding: 10px 24px;
    }

    .user_info_zone .ant-divider {
        margin: 0 0 10px;
    }

    .user_waitlist_data, .user_timeline {
        margin-top: 10px;
    }

    .user_info_header {
        max-height: 100px;
        overflow: auto;
    }

    .user_info_zone .user_top_action .custom_big_btn {
        width: 115px;
        height: 60px;
    }

    .user_timeline .ant-timeline .ant-timeline-item {
        padding-bottom: 7px;
    }

    .green_color1 {
        color: #fff; 
        background-color: #5f9562; 
        border-color: #5f9562;
    }

    .yellow_color1 {
        color: #fff;
        background-color: #f9bd58;
        border-color: #f9bd58;
    }

    .yellow_color2 {
        color: #fff; 
        background-color: #e78156; 
        border-color: #e78156;
    }

    .red_color1 {
        color: #fff; 
        background-color: #e72333; 
        border-color: #e72333;
    }

    @media screen and (max-width: 768px) {
        .ant-divider {
            margin: .5rem 0;
        }
        .ant-list-item {
            padding: .3rem .5rem;
        }
        .date-selector-item {
            min-width: 60px;
            padding: 6px 8px;
            font-size: 12px;
        }
        .user_info_zone .ant-drawer-body {
            padding: .3rem .5rem;
        }
    }
</style>
